import * as graphql from "../../../resolvers-types";
import { reviewHistoryRepeater } from "../../sampleData/review-history/review-history";
import serviceNotesHistory from "../../sampleData/review-history/service-review-notes-history";

export const onFeedbackAction: graphql.IActionTrigger = {
  Trigger: "onFeedback",
  CommandSet: {
    FirstCommandId: "1",
    ExecuteCommandsInParallel: false,
    Commands: [
      {
        Id: "1",
        Instruction: {
          Name: "SetState",
        },
        SkipCommand: "!isEmpty(State.FeedbackData)",
        Parameters: [
          {
            Name: "Bindings",
            Value: {
              "State.FeedbackData": "Event ",
            },
          },
        ],
      },
    ],
  },
};

export const reviewsActions = [
  {
    Trigger: "onReviewAction",
    CommandSet: {
      Id: "0x445312",
      FirstCommandId: "1",
      ExecuteCommandsInParallel: false,
      Commands: [
        {
          Id: "1",
          Instruction: {
            Name: "CallService",
          },
          Parameters: [{ Name: "ServiceName", Value: "NewReview" }],
          NextCommandIdOnFailure: "2",
        },
        {
          Id: "2",
          Instruction: {
            Name: "ShowMessage",
          },
          Parameters: [
            { Name: "Message", Value: "Save Failed." },
            { Name: "ShowOkButton", Value: true },
          ],
        },
      ],
    },
  },
  {
    Trigger: "onCreateTextNote",
    CommandSet: {
      Id: "weugf46",
      FirstCommandId: "1",
      ExecuteCommandsInParallel: false,
      Commands: [
        {
          Id: "1",
          Instruction: {
            Id: "1",
            Name: "OpenModalPopup",
          },
          Parameters: [
            { Name: "Title", Value: "Enter Feedback" },
            { Name: "ModalPopupId", Value: "AddTextNotePopup" },
          ],
          NextCommand: "CommandResult=='Save'?'2':null",
        },
        {
          Id: "2",
          Instruction: {
            Name: "CallService",
          },
          Parameters: [{ Name: "ServiceName", Value: "NewTextNote" }],
          NextCommandIdOnFailure: "3",
        },
        {
          Id: "3",
          Instruction: {
            Name: "ShowMessage",
          },
          Parameters: [
            { Name: "Message", Value: "Save Failed." },
            { Name: "ShowOkButton", Value: true },
          ],
        },
      ],
    },
  },
  {
    Trigger: "onCreateVoiceNote",
    CommandSet: {
      Id: "weugf46",
      FirstCommandId: "1",
      ExecuteCommandsInParallel: false,
      Commands: [
        {
          Id: "1",
          Instruction: {
            Name: "CallService",
          },
          Parameters: [{ Name: "ServiceName", Value: "NewVoiceNote" }],
          NextCommandIdOnFailure: "3",
        },
        {
          Id: "3",
          Instruction: {
            Name: "ShowMessage",
          },
          Parameters: [
            { Name: "Message", Value: "Save Failed." },
            { Name: "ShowOkButton", Value: true },
          ],
        },
      ],
    },
  },
  //
  {
    Trigger: "onShowHistory",
    CommandSet: {
      Id: "weusdgf46",
      FirstCommandId: "1",
      ExecuteCommandsInParallel: false,
      Commands: [
        {
          Id: "1",
          Instruction: {
            Id: "1",
            Name: "CallService",
          },
          Parameters: [
            { Name: "ServiceName", Value: "review-notes-history" },
            //{ Name: "Form", Value: "AddAssetForm" },
          ],
          NextCommandIdOnSuccess: "2",
        },
        {
          Id: "2",
          Instruction: {
            Id: "1",
            Name: "OpenModalPopup",
          },
          Parameters: [
            { Name: "Title", Value: "Your Feedback" },
            { Name: "ModalPopupId", Value: "HistoryNotePopup" },
          ],
        },
      ],
    },
  },
  {
    Trigger: "onShowInfo",
    CommandSet: {
      Id: "weusdwwgf46",
      FirstCommandId: "0",
      ExecuteCommandsInParallel: false,
      Commands: [
        {
          Id: "0",
          Instruction: {
            Id: "0",
            Name: "SetState",
          },
          Parameters: [
            {
              Name: "Bindings",
              Value: {
                "State.NGReviewSelectedItemForService": "Event.Item",
                "State.NGReviewSelectedItem": "Event.Item",
              },
            },
          ],
          NextCommandIdOnSuccess: "1",
        },
        {
          Id: "1",
          Instruction: {
            Id: "0",
            Name: "CallService",
          },

          Parameters: [{ Name: "ServiceName", Value: "GetComponent" }],
          NextCommandIdOnSuccess: "2",
          NextCommandIdOnFailure: "2",
        },
        {
          Id: "2",
          Instruction: {
            Id: "1",
            Name: "OpenModalPopup",
          },
          Parameters: [
            { Name: "Title", Value: "Information" },
            { Name: "ModalPopupId", Value: "InfoPopup" },
          ],
        },
      ],
    },
  },
]

export const reviewServices = [
  {
    Name: "GetReviewByItem",
    Service: "reviews-by-item",
    Trigger: "Action",
    Fields: [
      {
        Name: "Action",
        Required: true,
        Value: "Reaction",
      },
      {
        Name: "Reaction",
        Required: true,
        Value: "",
        Bindings: {
          Value: "Event.Reaction",
        },
      },
      {
        Name: "Item",
        Required: false,
        Value: "",
        Bindings: {
          Value: "Event.Item",
        },
      },
    ],
  },
  {
    Name: "NewReview",
    Service: "reviews.new",
    Trigger: "Action",
    Type: "Publish",
    Fields: [
      {
        Name: "Action",
        Required: true,
        Value: "Reaction",
      },
      {
        Name: "Reaction",
        Required: true,
        Value: "",
        Bindings: {
          Value: "Event.Reaction",
        },
      },
      {
        Name: "Item",
        Required: false,
        Value: "",
        Bindings: {
          Value: "Event.Item",
        },
      },
    ],
  },
  {
    Name: "NewTextNote",
    Service: "reviews.new",
    Trigger: "Action",
    Type: "Publish",
    Fields: [
      {
        Name: "Action",
        Required: true,
        Value: "AddNote",
      },
      {
        Name: "Text",
        Required: true,
        Value: {},
        Bindings: {
          Value: "State.NGReviewText.Text",
        },
      },
      {
        Name: "NoteType",
        Required: true,
        Value: "Text",
      },
      {
        Name: "Item",
        Required: false,
        Value: "",
        Bindings: {
          Value: "Event.Item",
        },
      },
    ],
  },
  {
    Name: "NewVoiceNote",
    Service: "reviews.new",
    Trigger: "Action",
    Type: "Publish",
    Fields: [
      {
        Name: "Action",
        Required: true,
        Value: "AddNote",
      },
      {
        Name: "File",
        Required: true,
        Value: {},
        Bindings: {
          Value: "Event.FileName",
        },
      },
      {
        Name: "NoteType",
        Required: true,
        Value: "Audio",
      },
      {
        Name: "Item",
        Required: false,
        Value: "",
        Bindings: {
          Value: "Event.Item",
        },
      },
    ],
  },
];

export const addTextNotePopup: graphql.Dialog = {
  __typename: "Dialog",
  Id: "AddTextNotePopup",
  Title: "Add Asset",
  InnerDialogStyle: {
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "var(--md-sys-color-background)",
  },
  TitleStyle: {
    color: "var(--md-sys-color-on-background)",
    fontFamily: "var(--md-sys-heading-large-font)",
    fontSize: "var(--md-sys-heading-medium-size)",
    fontWeight: "var(--md-sys-body-large-weight)",
    padding: "16px",
    "&>div": {
      justifyContent: "flex-start"
    }
  },
  ContentContainer: {
    __typename: "SimpleContainer",
    Id: "/1/",
    Items: [
      {
        Typename: "Form",
        Id: "AddTextNoteForm",
        UniqueName: "AddTextNoteForm",
        Style: {
          gap: "20px",
        },
        Items: [
          {
            __typename: "SimpleContainer",
            Id: "0xa18ds",
            Style: {
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%",
            },
            Items: [
              {
                __typename: "InputField",
                Id: "2",
                Multiline: true,
                Rows: 10,
                Placeholder: "Type your thoughts...",
                Name: "Text",
              },
            ]
          },
          {
            __typename: "SimpleContainer",
            Id: "0xa18ds",
            Style: {
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
            },
            Items: [
              {
                __typename: "Button",
                Id: "3",
                Name: "Add",
                Label: "Save",
                Actions: [
                  {
                    Trigger: "onClick",
                    CommandSet: {
                      FirstCommandId: "0",
                      ExecuteCommandsInParallel: false,
                      Commands: [
                        {
                          Id: "0",
                          Instruction: {
                            Name: "SetState",
                          },
                          Parameters: [
                            {
                              Name: "Bindings",
                              Value: {
                                "State.NGReviewText": "Form",
                              },
                            },
                          ],
                          NextCommandIdOnSuccess: "2",
                        },
                        {
                          Id: "2",
                          Instruction: {
                            Name: "ClearForm",
                          },
                          Parameters: [{ Name: "Form", Value: "AddTextNoteForm" }],
                          NextCommandIdOnSuccess: "3",
                        },
                        {
                          Id: "3",
                          Instruction: {
                            Name: "CloseModalPopup",
                          },
                          Parameters: [
                            { Name: "ModalPopupId", Value: "AddTextNotePopup" },
                            { Name: "CommandResult", Value: "Save" },
                          ],
                        },
                      ],
                    },
                  },
                ],
                Style: {
                  width: "100%",
                },
                Classes: [
                  "button-primary-large"
                ]
              },
              {
                __typename: "Button",
                Name: "CloseModal",
                Id: "4",
                Label: "Close",
                Actions: [
                  {
                    Trigger: "onClick",
                    CommandSet: {
                      FirstCommandId: "1",
                      ExecuteCommandsInParallel: false,
                      Commands: [
                        {
                          Id: "1",
                          Instruction: {
                            Name: "CloseModalPopup",
                          },
                          Parameters: [{ Name: "ModalPopupId", Value: "AddTextNotePopup" }],
                        },
                      ],
                    },
                  },
                ],
                Style: {
                  width: "100%",
                },
                Classes: ["button-secondary-large"]
              },
            ]
          }
        ],
        Layout: {
          __typename: "LinearLayout",
          Id: "21",
          // SpacingExtraSmall: "1em",
          DirectionExtraSmall: "column",
        },
      } as graphql.Form,
    ],
  } as graphql.SimpleContainer,
};

//InfoPopup

export const infoPopup: graphql.Dialog = {
  __typename: "Dialog",
  Id: "InfoPopup",
  InnerDialogStyle: {
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "var(--md-sys-color-background)",
  },
  TitleStyle: {
    color: "var(--md-sys-color-on-background)",
    fontFamily: "var(--md-sys-heading-large-font)",
    fontSize: "var(--md-sys-heading-medium-size)",
    fontWeight: "var(--md-sys-body-large-weight)",
    padding: "16px",
    "&>div": {
      justifyContent: "flex-start"
    }
  },
  ContentContainer: {
    __typename: "SimpleContainer",
    Id: "/1/",
    Items: [
      {
        __typename: "Form",
        Id: "ComponentDetails",
        Bindings: { Data: "State.NGReviewSelectedItem" },
        Style: {
          gap: "20px"
        },
        Items: [
          {
            __typename: "SimpleContainer",
            Id: "0xa18a",
            Items: [
              {
                __typename: "Label",
                Id: "0xa18",
                DefaultValue: "Component Name",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-heading-large-weight)",
                },
              },
              {
                __typename: "Label",
                Id: "223234",
                Name: "Name",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-body-small-weight)",
                },
              },
            ]
          },
          {
            __typename: "SimpleContainer",
            Id: "0xa18b",
            Items: [
              {
                __typename: "Label",
                Id: "0xar18",
                DefaultValue: "Component Serial Number",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-heading-large-weight)",
                },
              },
              {
                __typename: "Label",
                Id: "223rr234",
                Name: "SerialNumber",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-body-small-weight)",
                },
              },
            ]
          },
          {
            __typename: "SimpleContainer",
            Id: "0xa18d",
            Items: [
              {
                __typename: "Label",
                Id: "0xaewrewr18",
                DefaultValue: "Description",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-heading-large-weight)",
                },
                Bindings: {
                  Visible: "FormData.Description",
                },
              },
              {
                __typename: "Label",
                Id: "223rdsfwer234",
                Name: "Description",
                Style: {
                  color: "var(--md-sys-color-on-background)",
                  fontFamily: "var(--md-sys-heading-large-font)",
                  fontSize: "var(--md-sys-heading-small-size)",
                  fontWeight: "var(--md-sys-body-small-weight)",
                }
              },
            ]
          }
        ],
      },
    ],
  } as unknown as graphql.SimpleContainer,
};

export const historyNotePopup: graphql.Dialog = {
  __typename: "Dialog",
  Id: "HistoryNotePopup",
  InnerDialogStyle: {
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "var(--md-sys-color-background)",
  },
  TitleStyle: {
    color: "var(--md-sys-color-on-background)",
    fontFamily: "var(--md-sys-heading-large-font)",
    fontSize: "var(--md-sys-heading-medium-size)",
    fontWeight: "var(--md-sys-body-large-weight)",
    padding: "16px",
    "&>div": {
      justifyContent: "flex-start"
    }
  },
  ContentContainer: {
    __typename: "SimpleContainer",
    Id: "/1/",
    Services: [serviceNotesHistory],
    Style: {
      gap: "20px"
    },
    Items: [
      reviewHistoryRepeater,
      {
        __typename: "Button",
        Name: "CloseModal",
        Id: "4",
        Label: "Close",
        Classes: ["button-secondary-large"],
        Actions: [
          {
            Trigger: "onClick",
            CommandSet: {
              FirstCommandId: "1",
              ExecuteCommandsInParallel: false,
              Commands: [
                {
                  Id: "1",
                  Instruction: {
                    Name: "CloseModalPopup",
                  },
                  Parameters: [{ Name: "ModalPopupId", Value: "HistoryNotePopup" }],
                },
              ],
            },
          },
        ],
      },
      // {
      //   Typename: "Form",
      //   Id: "HistoryNoteForm",
      //   UniqueName: "HistoryNoteForm",
      //   Items: [
      //     {
      //       __typename: "Label",
      //       Id: "0xa18",
      //       Value: "Text",
      //       DefaultValue: 3,
      //       Name: "NoteType",
      //     },
      //     {
      //       __typename: "InputField",
      //       Id: "2",
      //       Multiline: true,
      //       Rows: 10,
      //       Label: "Type your thoughts...",
      //       Name: "Text",
      //     },
      //     {
      //       __typename: "Button",
      //       Id: "3",
      //       Name: "Add",
      //       Label: "Save",
      //       Actions: [
      //         {
      //           Trigger: "onClick",
      //           CommandSet: {
      //             FirstCommandId: "0",
      //             ExecuteCommandsInParallel: false,
      //             Commands: [
      //               {
      //                 Id: "0",
      //                 Instruction: {
      //                   Name: "SetState",
      //                 },
      //                 Parameters: [
      //                   {
      //                     Name: "Bindings",
      //                     Value: {
      //                       "State.NGReviewText": "Form",
      //                     },
      //                   },
      //                 ],
      //                 NextCommandIdOnSuccess: "2",
      //               },
      //               {
      //                 Id: "2",
      //                 Instruction: {
      //                   Name: "ClearForm",
      //                 },
      //                 Parameters: [{ Name: "Form", Value: "AddTextNoteForm" }],
      //                 NextCommandIdOnSuccess: "3",
      //               },
      //               {
      //                 Id: "3",
      //                 Instruction: {
      //                   Name: "CloseModalPopup",
      //                 },
      //                 Parameters: [
      //                   { Name: "ModalPopupId", Value: "AddTextNotePopup" },
      //                 ],
      //               },
      //             ],
      //           },
      //         },
      //       ],
      //     },
      //     {
      //       __typename: "Button",
      //       Name: "CloseModal",
      //       Id: "4",
      //       Label: "Close",
      //       Actions: [
      //         {
      //           Trigger: "onClick",
      //           CommandSet: {
      //             FirstCommandId: "1",
      //             ExecuteCommandsInParallel: false,
      //             Commands: [
      //               {
      //                 Id: "1",
      //                 Instruction: {
      //                   Name: "CloseModalPopup",
      //                 },
      //                 Parameters: [
      //                   { Name: "ModalPopupId", Value: "AddTextNotePopup" },
      //                 ],
      //               },
      //             ],
      //           },
      //         },
      //       ],
      //     },
      //   ],
      //   Layout: {
      //     __typename: "LinearLayout",
      //     Id: "21",
      //     // SpacingExtraSmall: "1em",
      //     DirectionExtraSmall: "column",
      //   },
      // } as graphql.Form,
    ],
  } as graphql.SimpleContainer,
};
